module.exports = __webpack_public_path__ + "static/img/memberDHH.f7526d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberDHH.png
// module id = 83VF
// module chunks = 0